import React from 'react';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    width: 90%;
    max-width: 440px;
    padding: 2rem;
    background: rgba(30, 27, 75, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    backdrop-filter: blur(16px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    color: rgba(255, 255, 255, 0.85);
    align-items: center;
    text-align: center;

    & > p {
        margin: 0;
        font-size: 0.92rem;
        line-height: 1.6;
        color: rgba(255, 255, 255, 0.65);
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    gap: 0.8rem;
    justify-content: center;
`;

const Button = styled.button`
    padding: 0.55rem 1.6rem;
    border-radius: 12px;
    border: none;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;

    background: ${props => props.$primary
        ? 'linear-gradient(135deg, #6366f1, #8b5cf6)'
        : 'rgba(255, 255, 255, 0.08)'};
    color: ${props => props.$primary ? 'white' : 'rgba(255, 255, 255, 0.6)'};
    border: ${props => props.$primary ? 'none' : '1px solid rgba(255, 255, 255, 0.1)'};
    box-shadow: ${props => props.$primary ? '0 3px 14px rgba(99, 102, 241, 0.3)' : 'none'};

    &:hover {
        transform: translateY(-1px);
        background: ${props => props.$primary
            ? 'linear-gradient(135deg, #4f46e5, #7c3aed)'
            : 'rgba(255, 255, 255, 0.12)'};
        color: ${props => props.$primary ? 'white' : 'rgba(255, 255, 255, 0.85)'};
    }
    &:active { transform: translateY(0); }
`;

const ConfirmationModal = ({ onClose, onConfirm, message }) => {
    const { t } = useTranslation();

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <p>{message}</p>
                <ButtonContainer>
                    <Button $primary onClick={onConfirm}>{t('ConfirmButton')}</Button>
                    <Button onClick={onClose}>{t('ConfirmButtonNo')}</Button>
                </ButtonContainer>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ConfirmationModal;
